import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <h1 className="text-3xl md:text-5xl font-semibold tracking-tight mb-6">Politique de confidentialite</h1>
          <p className="text-muted-foreground mb-10 leading-relaxed">
            Cette politique explique comment FastTask collecte, utilise et protege vos donnees personnelles.
          </p>

          <section className="space-y-8 text-sm md:text-base leading-relaxed text-muted-foreground">
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Donnees collectees</h2>
              <p>
                Nous collectons uniquement les donnees necessaires au traitement de vos demandes: nom, email,
                telephone, informations d'entreprise et besoins exprimes via nos formulaires.
              </p>
            </div>

            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Finalites</h2>
              <p>
                Les donnees sont utilisees pour repondre a vos demandes, proposer des solutions adaptees,
                et ameliorer la qualite de nos services.
              </p>
            </div>

            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Base legale</h2>
              <p>
                Le traitement repose sur votre consentement et/ou l'interet legitime de FastTask a assurer le suivi commercial et la relation client.
              </p>
            </div>

            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Vos droits</h2>
              <p>
                Conformement au RGPD, vous disposez d'un droit d'acces, de rectification, d'effacement, d'opposition,
                de limitation et de portabilite. Pour exercer vos droits, contactez: contact@fasttask.agency.
              </p>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
